import React, { useReducer, useContext, useState } from 'react';
import FallbackPage from '../../pages/Error/Fallback.component';
import { postLogsToServer } from '../../utils/ApiFunctions';
import LoggerContext from './Logger.context';
import { actionSpreader, reducer, actionTypes } from './Reducer';
import { FormContext } from '../Form.context';

class LoggerContextProvider extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
        this.log = this.log.bind(this);
        this.logErrorToService = this.logErrorToService.bind(this);
        this.flushLogs = this.flushLogs.bind(this);
        this.accumulate = this.accumulate.bind(this);
    }

    componentDidMount() {
        this.intervalId = setInterval(() => this.flushLogs(), 5000);
    }

    componentWillUnmount() {
        if (this.intervalId) clearInterval(this.intervalId);
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        const { getIncrementedCorId } = this.props;
        // eslint-disable-next-line no-undef
        const correlationId = getIncrementedCorId();
        const message = `${correlationId || ''} CPTT_MICROFRONTEND ERROR: ${new Date()} ${
            error?.message
        } ${errorInfo?.componentStack}`;
        this.logErrorToService(message);
        this.log(message);
        this.setState({ hasError: true });
    }

    logErrorToService(errorLog) {
        // make an api call to backend service
        postLogsToServer([errorLog]).catch((err) => {
            this.log(err?.message);
            // eslint-disable-next-line no-console
            console.log('Error logging to server:', err);
        });
    }

    accumulate(message) {
        const { dispatch } = this.props;
        dispatch(actionSpreader(actionTypes.ADD_TO_CONTAINER, message));
    }

    log(message = '') {
        if (process.env.ENV === 'local') {
            // eslint-disable-next-line no-console
            console.log(`${new Date()} ${message}`);
        } else {
            // eslint-disable-next-line no-undef
            const { getIncrementedCorId } = this.props;
            const correlationId = getIncrementedCorId();
            this.accumulate(
                `${correlationId || ''} CPTT_MICROFRONTEND LOG:  ${new Date()} ${message}`
            );
        }
    }

    async flushLogs() {
        const { container, dispatch } = this.props;
        if (!container.length) return;
        // logtoservice and flush the store
        postLogsToServer(container)
            .then((res) => {
                if (res?.status === 200) {
                    dispatch(actionSpreader(actionTypes.FLUSH_CONTAINER));
                }
            })
            .catch((err) => {
                this.log(err?.message);
                // eslint-disable-next-line no-console
                console.log('Error logging to server:', err);
            });
    }

    render() {
        const { hasError } = this.state;
        if (hasError) {
            return <FallbackPage />;
        }
        return (
            <LoggerContext.Provider value={{ log: this.log }}>
                {this.props.children}
            </LoggerContext.Provider>
        );
    }
}

export default function (props) {
    const [{ container }, dispatch] = useReducer(reducer, { container: [] });
    const { getIncrementedCorId } = useContext(FormContext);
    const [hasError, setHasError] = useState(false);

    const fallbackError = () => {
        setHasError(true);
    };
    window.addEventListener('error', fallbackError);
    window.addEventListener('unhandledrejection', fallbackError);

    if (hasError) {
        return <FallbackPage />;
    }
    return (
        <LoggerContextProvider
            {...props}
            getIncrementedCorId={getIncrementedCorId}
            container={container}
            dispatch={dispatch}
        />
    );
}
